export function isFileStream(data) {
  return !!(data instanceof Blob || data instanceof ArrayBuffer);
}

export const isExternal = (path) => /^(https?:|mailto:|tel:)/.test(path);

export const isFunction = (val) => typeof val === 'function';

/**
   * 终端判断
   * @return 'android','iPhone','undefined' 不支持的设备类型
   */
export const isJudgeDevice = () => {
  const u = navigator.userAgent;
  return u.indexOf('Android') > -1 ? 'Android' : u.indexOf('iPhone') > -1 ? 'IOS' : 'undefined';
};

export const isWeChatBrowser = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf('micromessenger') !== -1;
};

/**
 * @description 是否是企业微信打开
 * @returns {boolean}
 */
export const isWorkWeChatBrowser = () => {
  const ua = navigator.userAgent.toLowerCase();
  return /wxwork/i.test(ua);
};

/**
 * 判断是否是在App环境下
 * @returns {boolean}
 */
export const isInApp = () => [
  'baic-app-ios',
  'baic-app-android',
  'baic-orv-app-android',
  'baic-orv-app-ios',
].some(v => navigator.userAgent.includes(v));

/**
 * 判断是否是悦野圈app
 * @returns {boolean}
 */
export const isYueYeApp = () => navigator.userAgent.includes('baicorvApp');
